'use client';

import { Link, Stack } from '@chakra-ui/react';
import { Text } from '../components/Text';
import { useTranslation } from 'react-i18next';
import { NavigateBar } from '../components/NavigateBar';

export const Introduction = (props: any) => {
    const { t } = useTranslation();
    return (
        <>
            <Stack spaceY={2}>
                <Text trans="introduction.hello" />
                <Text trans="introduction.operatingInstructions" />
                <Text
                    trans={`${t('introduction.support')} `}
                    children={
                        <Link variant="plain" href="mailto:help@outbankapp.com">
                            help@outbankapp.com
                        </Link>
                    }
                />
                <Text trans="introduction.confidential" />
            </Stack>

            <NavigateBar mt={10} continuePath="/general" />
        </>
    );
};
